__turbopack_context__.v({
  "profile-dropdown-summary-client": "X_BuvG_profile-dropdown-summary-client",
  "profile-dropdown-summary-client__chip": "X_BuvG_profile-dropdown-summary-client__chip",
  "profile-dropdown-summary-client__icon": "X_BuvG_profile-dropdown-summary-client__icon",
  "profile-dropdown-summary-client__id": "X_BuvG_profile-dropdown-summary-client__id",
  "profile-dropdown-summary-client__inner": "X_BuvG_profile-dropdown-summary-client__inner",
  "profile-dropdown-summary-client__name": "X_BuvG_profile-dropdown-summary-client__name",
  "profile-dropdown-summary-client__photo": "X_BuvG_profile-dropdown-summary-client__photo",
});
